import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, useRoute } from '@nuxtjs/composition-api';
import * as pages from '@/constants/pages';
import CloseIcon from '~/assets/svg/close.vue.svg';


export default /*#__PURE__*/_defineComponent({
  __name: 'TopNotification',
  setup(__props) {

const EXCLUDED_URLS = [
  pages.JOBS_MY_MATCHES_PAGE.name,
  pages.SEARCH_IMAGE_PREVIEW_PAGE.name,
  pages.REFERRAL_PROMOTION_PAGE.name,
  'login-external',
];

const TOP_NOTIFICATION_LOCAL_STORAGE_KEY = 'hide-top-notification-salesgpt';

const route = useRoute();

const isClosed = ref(false);

function handleClose() {
  localStorage.setItem(TOP_NOTIFICATION_LOCAL_STORAGE_KEY, 'true');
  isClosed.value = true;
}

const isVisible = computed(() => {
  const hideTopNotification = process.client && localStorage.getItem(TOP_NOTIFICATION_LOCAL_STORAGE_KEY);

  if (hideTopNotification || (route.value.name && EXCLUDED_URLS.includes(route.value.name))) return false;

  return isClosed.value;
});

return { __sfc: true,EXCLUDED_URLS, TOP_NOTIFICATION_LOCAL_STORAGE_KEY, route, isClosed, handleClose, isVisible, CloseIcon }
}

})